import 'ol/ol.css';
import { Vector as VectorLayer } from 'ol/layer'
import { Style, Stroke, Fill, Text } from 'ol/style.js';

export default class BoundaryPolygonLayer extends VectorLayer {
    constructor(map) {
        super({
            name: 'boundary',
            style: (feature) => this.styleFunction(feature)
        });
        this.map = map;
        this.map?.addLayer(this);
    }

    styleFunction = function (feature) {
        const nm = feature.getProperties()['SIGUNGU_NM'];
        return new Style({
            stroke: new Stroke({
                color: 'rgba( 200, 200, 200, 0.7)',
                width: 4
            }),
            fill: new Fill({
                color: 'rgb(33, 43, 54)'
            }),
            text: new Text({
                font: "10px 'NanumSquareNeo', 'Nanum Gothic', sans-serif",
                scale: 2,
                text: nm.replace('수원시', '').trim(),
                fill: new Fill({ color: '#AAAAAA' }),
                //stroke: new Stroke({ color: 'gray', width: 1 })
            })
        })
    };
}